<template>
  <fragment>
    <v-container fluid pa-0>
      <v-layout justify-center column fill-height>
        <!-- テキストエリア -->
        <v-flex grow>
          <v-layout row>
            <v-flex grow style="max-width: 300px;min-width: 300px;">
              <CInput
                      v-model="localValue"
                      name="keyword"
                      remarks=""
                      @update:value="onChange"
                      style="margin-left: 12px"
                      :lazy="400"
                      placeholder="パーティー, ワインに合う"

              />
            </v-flex>
            <v-flex style="min-width: 150px">
              <template v-for="(candidate, index) in ownCandidates">
                <v-layout v-if="localValue !== candidate" :key="index" row fill-height style="align-items: baseline">
                  <CButton
                          class="mt-0 mx-5"
                          small
                          variant="ghost"
                          color="info"
                          @click="() => onAddContent(candidate)"
                  >
                    {{candidate}}
                  </CButton>

                </v-layout>
              </template>
            </v-flex>
          </v-layout>
        </v-flex>

      </v-layout>
    </v-container>

  </fragment>
</template>

<script>
import TextField from "./text";

export default {
  components: {
    TextField
  },
  props: {
    value:{},
    resourceName: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      default: "edit",
      validator: value => ["show", "create", "edit"].indexOf(value) !== -1
    }
  },
  data() {
    return {
      ownCandidates: []
    };
  },
  computed: {
    isShowMode() {
      return this.mode === "show";
    },
    isCreateMode() {
      return this.mode === "create";
    },
    isEditMode() {
      return this.mode === "edit";
    },
    candidates() {
      return this.$store.getters[`common/keywords/options/options`];
    },
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    onAddContent(keyword) {
      if (keyword === '' || keyword === null) {
        return;
      }
      this.localValue = keyword;
      this.ownCandidates = [];
      this.$store.commit(
        `common/keywords/options/initialize`
      );
    },
    onDeleteContent(input, index) {
      input.splice(index, 1);
    },
    onChange(v) {
      if(v === ""){
        this.ownCandidates = [];
      }
      this.$store.dispatch(
        `common/keywords/options/index`,
        this.localValue
      ).then(() => {
          this.ownCandidates = this.candidates;
          if(this.candidates.length > 0){
          }
        }
      );
    }
  }
};
</script>
<style module lang="scss">
.content-card {
  margin: 5px 0;
}
</style>
